(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evo-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const menu=event.target.closest('.evo-jewelry-menu[open]');
  if(menu){event.preventDefault();event.stopPropagation();menu.open=false;menu.querySelector('summary').focus();}
},true);
document.addEventListener('click',event=>{
  document.querySelectorAll('.evo-jewelry-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
